import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { EmailTypeModel } from 'src/models';

const emailTypeAdapter: AdapterFunc<GQL.EmailTypeModel, EmailTypeModel> = (input) => ({
  id: input.id,
  name: input.name!,
  description: input.description!,
  createdAt: input.createdAt,
  updatedAt: input.updatedAt,
});

export default emailTypeAdapter;
